(() => {
  const ELEMENT_NAME = "product-form"
  class ProductForm extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.$form = this.querySelector("form");
      
      this.init()
    }

    init() {
      this.addEventListener("submit", (evt) => {
        evt.preventDefault();

        this.addToCart();
      });
    }

    addToCart() {
      this.toggleAttribute("loading");

      fetch("/cart/add.js", {
        method: "POST",
        body: new FormData(this.$form),
      })
        .then((res) => res.json())
        .then((json) => {
          document.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: json.id,
                quantity: 1,
              },
            })
          );
        })
        .catch((err) => console.warn("CART", err))
        .finally(() => this.toggleAttribute("loading"));
    }
  }

  customElements.define(ELEMENT_NAME, ProductForm)
})()